<template>
  <div ref="state_indicator" id="state-indicator" class="state-indicator"></div>

  <NotificationMessages />
  <Tooltip />

  <router-view></router-view>

  <GTMAnalytics/>

</template>

<script setup>
  import {ref}                                   from 'vue';
  import {onMounted, onUnmounted, onBeforeMount} from 'vue';
  import NotificationMessages                    from '@/vue/Elements/Tools/Notifications/NotificationMessages.vue';
  import Tooltip                                 from '@/vue/Elements/Tools/Tooltip.vue';
  import GTMAnalytics                            from '@/vue/Views/Webmail/Sections/GTMAnalytics.vue';
  import LayoutSettingsController                from '@/js/Webmail/LayoutSettingsController';
  import DomController                           from '@/js/Webmail/DomController';
  import PopupController                         from '@/js/Webmail/PopupController';
  import SAPOMailConfig                          from '@/SAPOMailConfig';
  import KeyboardController                      from '@/js/Webmail/Keyboard/KeyboardController';
  import BindSession from '@/js/Webmail/BindSession';
  import WindowEvents from '@/js/Common/Events/WindowEvents';

  const state_indicator = ref();
  const color_scheme    = window.matchMedia('(prefers-color-scheme: dark)');

  onBeforeMount(() => {
    setBodyClasses();
    BindSession.start();

    WindowEvents.on([
      ['online'          , onOnline],
      ['visibilitychange', onVisibilityChange],
    ]);
  })

  onMounted(() => {
    setStateIndicator();
    window.addEventListener('unload', onWindowUnload);
    window.addEventListener('resize', onWindowResize);
    window.addEventListener('drop', onWindowDrop);
    window.addEventListener('dragover', onWindowDragOver);
    color_scheme.addEventListener('change', setTheme);
    KeyboardController.addEventListeners();
  })

  onUnmounted(() => {
    KeyboardController.removeEventListeners();
    color_scheme.removeEventListener('change', setTheme);
    window.removeEventListener('resize', onWindowResize);
    window.removeEventListener('unload', onWindowUnload);
    window.removeEventListener('drop', onWindowDrop);
    window.removeEventListener('dragover', onWindowDragOver);
    BindSession.stop();

    WindowEvents.destroy([
      ['online'          , onOnline],
      ['visibilitychange', onVisibilityChange],
    ]);
  })

  const onOnline = () => {
    BindSession.refresh();
  }

  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      BindSession.refresh();
    }
  }

  const onWindowUnload = () => {
    PopupController.closeAllPopups();
  }

  const onWindowDrop = (event) => {
    event.preventDefault();
  }

  const onWindowDragOver = (event) => {
    event.preventDefault();
  }

  const onWindowResize = () => {
    setStateIndicator();
  }

  const setTheme = (event) => {
    if (LayoutSettingsController.storage.theme_option !== 'automatic') {
      return;
    }

    LayoutSettingsController.theme = event.matches ? 'dark-theme' : 'light-theme';
  }

  const setStateIndicator = () => {
    let state = getComputedStyle(state_indicator.value, '::before').getPropertyValue('content');

    if (state !== LayoutSettingsController.state_indicator) {
      LayoutSettingsController.state_indicator = state.replace(/"/g, '');
    }
  }

  const setBodyClasses = () => {
    if (SAPOMailConfig.server && SAPOMailConfig.server.environment) {
      DomController.setBodyClass(
        SAPOMailConfig.server.environment.name
      )
    }
  }
</script>

<style lang="less">
  @import "./assets/styles/main.less";
</style>
